import { createSelector } from "reselect";
import { getProductImageData } from "../../../state/helpers.js";
import { frameSkuProp } from "../../../state/selectors.internal.js";
import { getFrame } from "./selectors.internal.js";
const frameImageProps = (_, props) => props;
const getFrameImage = createSelector(
  getFrame,
  frameSkuProp,
  frameImageProps,
  (frame, frameSku, frameImageProps2) => {
    if (!frame) {
      return void 0;
    }
    const { width } = frameImageProps2;
    return getProductImageData(frame, frameSku, width);
  }
);
export {
  frameImageProps,
  getFrameImage
};
//# sourceMappingURL=selectors.js.map
